// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"1acbed62","159":"86fe5a49","216":"490edaee","239":"2f822dd7","396":"4bbffb13","455":"ef4bc2c9","530":"9fd920c3","699":"83d711f2","970":"596fadf2","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};